import { GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, n__ } from '~/locale';
import DownstreamPipelineDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_mini_graph/downstream_pipeline_dropdown.vue?vue3';
/**
 * Renders the downstream portion of the pipeline mini graph.
 */ export default {
    name: 'DownstreamPipelines',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        DownstreamPipelineDropdown
    },
    props: {
        pipelines: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        totalCount: {
            type: Number,
            required: false,
            default: 0
        },
        pipelinePath: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'job-action-executed'
    ],
    data () {
        return {
            maxRenderedPipelines: 3
        };
    },
    computed: {
        totalPipelineCount () {
            return this.totalCount || this.pipelines.length;
        },
        pipelinesTrimmed () {
            return this.pipelines.length > this.maxRenderedPipelines ? this.pipelines.slice(0, this.maxRenderedPipelines) : this.pipelines;
        },
        shouldRenderCounter () {
            return this.totalPipelineCount > this.maxRenderedPipelines;
        },
        counterLabel () {
            return `+${this.totalPipelineCount - this.maxRenderedPipelines}`;
        },
        counterTooltipText () {
            return sprintf(n__('Pipelines|%{counterLabel} more downstream pipeline', 'Pipelines|%{counterLabel} more downstream pipelines', this.counterLabel), {
                counterLabel: this.counterLabel
            });
        }
    }
};
